import React, { useEffect, useState } from "react";
import { Tag, Image, Spin, Checkbox, Popover } from "@arco-design/web-react";
import { ITagList } from "@/data/creativeScriptProps";
import cs from "classnames";
import "./index.less";
import LoadingDom from "@/components/UI/LoadingDom";
interface ILabelSwitchingProps {
  tagList: ITagList;
  style?: React.CSSProperties;
  isLoading?: boolean;
  checkRenderProps?: (opt: ITagList) => void;
  renderProps?: (opt: any) => void;
}
const LabelSwitching: React.FC<ILabelSwitchingProps> = (props) => {
  const {
    tagList,
    style,
    isLoading,
    checkRenderProps = () => {
      //
    },
    renderProps,
  } = props;
  // 选择便签
  const [data, setData] = useState([]);

  // 获取已选内容
  const getCheckedInfo = () => {
    const checkedInfo = data
      .flatMap((tag) =>
        tag.children
          .filter((child) => child.checked)
          .map((child) => ({
            value: child.value,
            id: child.id,
            type: tag.title,
            children: child.children
              ?.filter((v) => v.checked)
              .map((v) => ({
                value: v.value,
                id: v.id,
              })),
          })),
      )
      .reduce((acc, item) => {
        const existing = acc.find((obj) => obj.type === item.type);
        if (existing) {
          existing.content.push({
            value: item.value,
            id: item.id,
            children: item.children,
          });
        } else {
          acc.push({
            type: item.type,
            content: [
              {
                value: item.value,
                id: item.id,
                children: item.children,
              },
            ],
          });
        }
        return acc;
      }, [])
      .map((v) => ({
        ...v,
        content: !v.content[0].id ? [] : v.content,
      }));
    return checkedInfo;
  };
  const handleTagClick = (opt, val) => {
    const { item, index } = opt;
    const { v, i } = val;
    const isAllClicked = item.children[i].label === "全部";

    if (v?.children && v.children.length) {
      v.children[0].checked = true;
    }
    const newTagList = data.map((tag, idx) => {
      if (idx !== index) return tag;

      let newChildren;
      if (isAllClicked) {
        newChildren = tag.children.map((child) =>
          child.label !== "全部" ? { ...child, checked: false } : child,
        );
      } else if (tag.checkAll) {
        newChildren = tag.children.map((child, childIdx) => {
          if (childIdx === 0) return { ...child, checked: false };
          if (childIdx === i) return { ...child, checked: !child.checked };
          return child;
        });
      } else {
        newChildren = tag.children.map((child) => ({
          ...child,
          checked: child.label === v.label ? !child.checked : false,
        }));
      }

      return { ...tag, children: newChildren };
    });

    if (
      isAllClicked ||
      newTagList[index].children.every((child) => !child.checked)
    ) {
      newTagList[index].children[0].checked = true;
    }

    setData(newTagList);
  };

  // 清除标签
  const closeTag = (item, val) => {
    const newTaglist = [...data];
    const itemIndex = newTaglist.findIndex((opt) => opt.title === item.title);
    const childrenIndex = newTaglist[itemIndex].children.findIndex(
      (opt) => opt.title === val.title,
    );
    newTaglist[itemIndex].children[childrenIndex].checked = false;
    if (newTaglist[itemIndex].children.every((v) => !v.checked)) {
      newTaglist[itemIndex].children[0].checked = true;
    }
    setData(newTaglist);
  };
  //   是否显示已选行
  const checkIfAnyCheckedExceptAll = (arr) => {
    for (const obj of arr) {
      for (const child of obj.children) {
        if (child.title !== "全部" && child.checked) {
          return true;
        }
      }
    }
    return false;
  };

  useEffect(() => {
    setData(tagList);
  }, [tagList]);
  useEffect(() => {
    checkRenderProps(getCheckedInfo());
  }, [data]);
  if (renderProps) {
    renderProps({
      closeTag,
      checkIfAnyCheckedExceptAll,
      data,
    });
  }
  return (
    <Spin loading={isLoading} icon={<LoadingDom />}>
      <div className="tag-root" style={style}>
        {data && data.length ? (
          data.map((item, index) => (
            <div key={index} style={{ display: "flex" }}>
              <span style={{ width: 40, paddingTop: 9 }}>{item.title}</span>
              <div className="row-tag">
                {item.children.map((v, i) => (
                  <Popover
                    position="bottom"
                    getPopupContainer={() => {
                      return document.querySelector(".tag-root");
                    }}
                    key={i}
                    trigger="hover"
                    content={
                      v?.children && v.children.length && v.checked ? (
                        <div className="second-checked">
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                            }}>
                            {v.children.map((v, i) => (
                              <div key={i}>
                                <Checkbox
                                  checked={v.checked}
                                  style={{ marginRight: 9 }}
                                  onChange={() => {
                                    v.checked = !v.checked;
                                    setData([...data]);
                                  }}
                                />
                                <p>{v.label}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )
                    }>
                    <div
                      key={v.title}
                      className={cs(
                        "tag-button",
                        v.checked ? "active-tag-button" : "",
                      )}
                      onClick={() => handleTagClick({ item, index }, { v, i })}>
                      {v.label}
                    </div>
                  </Popover>
                ))}
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </Spin>
  );
};

export default LabelSwitching;
